import {
  Boxes,
  Rocket,
  ShieldCheck,
  TrendingUp,
  Scale,
  FileText,
  Workflow,
  Quote,
  FlaskConical,
  BookOpen,
  Newspaper,
  Video,
  Building2,
  Briefcase,
  CalendarDays,
  Lock,
  Mail,
  type LucideIcon,
} from "lucide-react";
import { networkServices } from "@/data/network";

export interface MegaLink {
  label: string;
  href: string;
  description: string;
  icon?: LucideIcon;
}

export interface MegaGroup {
  heading?: string;
  links: MegaLink[];
}

export interface MegaPromo {
  eyebrow: string;
  title: string;
  body: string;
  href: string;
  cta: string;
  imageUrl?: string;
}

export interface MegaSection {
  label: string;
  href: string;
  groups: MegaGroup[];
  promo: MegaPromo;
  /** When set, render an industries rail (Network only). */
  industries?: { label: string; href: string; promo: MegaPromo }[];
}

const networkPromos: { label: string; href: string; promo: MegaPromo }[] = networkServices.map((s) => ({
  label: s.navTitle,
  href: `/network/${s.slug}`,
  promo: {
    eyebrow: s.eyebrow,
    title: s.heroTitle,
    body: s.heroSubtitle,
    href: `/network/${s.slug}`,
    cta: "Explore service",
  },
}));

export const megaNav: MegaSection[] = [
  {
    label: "Solution",
    href: "/solution",
    groups: [
      {
        links: [
          { label: "Build", href: "/solution#build", description: "Compose clinical AI on validated infrastructure.", icon: Boxes },
          { label: "Architecture", href: "/solution#architecture", description: "How the infrastructure fits into your stack.", icon: TrendingUp },
          { label: "Deploy", href: "/solution#deploy", description: "Ship to production with institutional SLAs.", icon: Rocket },
          { label: "Integrations", href: "/solution#integrations", description: "EHR, imaging, workflow, data, and AI systems.", icon: Workflow },
          { label: "Govern", href: "/solution#govern", description: "Built for regulatory and institutional governance.", icon: ShieldCheck },
        ],
      },
    ],
    promo: {
      eyebrow: "AI INFRASTRUCTURE LAYER",
      title: "One operating layer for clinical AI.",
      body: "From build to deploy to govern — the infrastructure health systems can defend.",
      href: "/solution",
      cta: "Explore the solution",
    },
  },
  {
    label: "Insights",
    href: "/insights",
    groups: [
      {
        
        links: [
          { label: "News", href: "/insights/news", description: "Announcements and field updates.", icon: Newspaper },
          { label: "Media", href: "/insights?kind=webinar", description: "Webinars, podcasts, and recorded sessions.", icon: Video },
          { label: "Blog", href: "/insights?kind=blog", description: "Perspectives on clinical AI in practice.", icon: FileText },
          { label: "Evidence", href: "/insights/evidence", description: "Studies, validation, and real-world data.", icon: FlaskConical },
          { label: "Literature", href: "/insights?kind=other", description: "Case studies, whitepapers, and downloadable assets.", icon: BookOpen },
        ],
      },
    ],
    promo: {
      eyebrow: "Featured",
      title: "Inside the deepc network.",
      body: "How institutions are running clinical AI as a managed program.",
      href: "/insights",
      cta: "Read insights",
    },
  },
  {
    label: "Company",
    href: "/company",
    groups: [
      {
        
        links: [
          { label: "Company", href: "/company", description: "Who we are and why we exist.", icon: Building2 },
          { label: "Careers", href: "/company/careers", description: "Build clinical AI infrastructure with us.", icon: Briefcase },
          { label: "Events", href: "/events", description: "Upcoming sessions, workshops, and meetups.", icon: CalendarDays },
          { label: "Contact", href: "mailto:contact@deepc.ai", description: "Talk to our team.", icon: Mail },
        ],
      },
    ],
    promo: {
      eyebrow: "Next event",
      title: "Join us at our next session.",
      body: "Working sessions, workshops, and field events for clinical AI teams.",
      href: "/events",
      cta: "See events",
    },
  },
];
